<template>
  <section class="home-eight">
    <div class="eight-inner">
      <div class="eight-left">
        <img :src="showInfo.imgUrl" alt="" />
        <ul>
          <li
            v-for="item in eightList"
            :key="item.title + item.key"
            @click="showInfo = item"
            :class="{ action: item.key === showInfo.key }"
          ></li>
        </ul>
      </div>
      <div class="eight-right">
        <h2>{{ showInfo.title }}</h2>
        <div class="number">{{ showInfo.number }}%</div>
        <p>{{ showInfo.text }}</p>
        <div class="btn">
          <a @click="tagChange(-1)"
            ><img src="../../../assets/home/home-left.svg" alt=""
          /></a>
          <a @click="tagChange(1)"
            ><img src="../../../assets/home/home-right.svg" alt=""
          /></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeEight',
  data() {
    return {
      showInfo: {},
      eightList: [
        {
          key: 'Mexico',
          title: '了解您的市场以加速销售',
          imgUrl: require('@/assets/home/HP-sec06-image-01-Mexico.svg'),
          text: '在墨西哥，服装和鞋类是最受欢迎的在线购物品类之一，约62%的墨西哥网购者在过去12个月内在线购买了服装产品。',
          number: 62
        },
        {
          key: 'Germany',
          title: '了解你的市场以推动你的销售',
          imgUrl: require('@/assets/home/HP-sec06-image-01-Germany.svg'),
          text: '在德国，时尚类产品（服装和鞋类）是最受欢迎的在线购物品类之一，约66%的德国消费者在过去一年中在线购买了服装和鞋类产品。',
          number: 66
        },
        {
          key: 'Australia',
          title: '了解你的市场以推动你的销售',
          imgUrl: require('@/assets/home/HP-sec06-image-01-Australia.svg'),
          text: '在澳大利亚，服装和配饰类产品的在线退货率相对较高。​根据2024年的数据，澳大利亚时尚电商市场的平均退货率为 18.1%，而服装电商市场的平均退货率为 22.7% 。',
          number: 22.7
        }
      ]
    }
  },
  mounted() {
    this.showInfo = this.eightList[0]
  },
  methods: {
    tagChange(num) {
      const sixRightListLength = this.eightList.length
      const itemIndex = this.eightList.findIndex(
        item => item.key === this.showInfo.key
      )
      if (num === 1) {
        const newIndex = itemIndex + num
        this.showInfo =
          this.eightList[newIndex >= sixRightListLength ? 0 : newIndex]
      } else {
        const newIndex = itemIndex + num
        this.showInfo =
          this.eightList[newIndex < 0 ? sixRightListLength - 1 : newIndex]
      }
    }
  }
}
</script>

<style scoped lang="less">
.home-eight {
  background-image: linear-gradient(90deg, #ffffff 50%, #f5f5f6 50%);
  .eight-inner {
    width: 1140px;
    height: 470px;
    margin: 0 auto;
    display: flex;
    .eight-left {
      flex: 1;
      padding: 20px 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      img {
        width: 100%;
        margin: auto;
      }
      p {
        margin: 20px 0;
      }
      ul {
        margin-top: auto;
        max-width: 100%;
        display: flex;
        gap: 5px;
        li {
          flex: 1;
          height: 10px;
          background-color: #ededed;
          cursor: pointer;
        }
        .action {
          background-color: #2f5ad9;
        }
      }
    }
    .eight-right {
      padding: 20px 60px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: end;
      line-height: 1.7;
      h2 {
        margin-top: auto;
        margin-bottom: 20px;
        font-size: 36px;
      }
      .number {
        color: #2f5ad9;
        font-size: 48px;
        font-weight: 700;
      }
      p {
        margin: 10px 0;
      }
      .btn {
        margin-top: 50px;
        display: flex;
        gap: 20px;
      }
    }
  }
}
</style>
